module.exports = __webpack_public_path__ + "img/IMG_8944.3d60ec7f.jpg";